<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="../assets/top2.png" class="footer-logo-img">
        </div>
        <div class="footer-info">
          <div class="info-item">
            <i class="icon-company"></i>
            <span>主办单位(版权所有)：扬州绿色产业投资发展控股（集团）有限责任公司</span>
          </div>
          <div class="info-item">
            <i class="icon-location"></i>
            <span>地址：扬州市江阳中路433号</span>
          </div>
          <div class="info-item">
            <i class="icon-phone"></i>
            <span>联系电话：0514-87863890</span>
          </div>
          <div class="info-item">
            <i class="icon-provider"></i>
            <span>运行管理：江苏日创信息科技有限公司</span>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          备案号: <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">苏ICP备2022042151号</a>
        </div>
        <div class="social-links">
          <a href="#" class="social-link" title="微信">
            <i class="icon-wechat"></i>
          </a>
          <a href="#" class="social-link" title="企业邮箱">
            <i class="icon-email"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterHtm'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(to right, #0a3d82, #1e5dbd, #0a3d82); /* 与导航栏匹配的蓝色渐变 */
  width: 100%;
  color: #fff;
  padding: 40px 0 20px;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  justify-content: space-between;
  align-items: center;
}

.footer-logo {
  margin-right: 30px;
  flex: 0 0 auto;
}

.footer-logo-img {
  max-width: 280px;
  height: auto;
  filter: brightness(1.1);
}

.footer-info {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  line-height: 28px;
}

.info-item {
  flex: 1 0 50%;
  display: flex;
  align-items: center;
  margin: 6px 0;
  font-size: 14px;
  position: relative;
  transition: transform 0.2s ease;
}

.info-item:hover {
  transform: translateX(5px);
}

.info-item i {
  margin-right: 10px;
  opacity: 0.8;
}

.icon-company:before { content: "🏢"; }
.icon-location:before { content: "📍"; }
.icon-phone:before { content: "📞"; }
.icon-provider:before { content: "⚙️"; }
.icon-wechat:before { content: "💬"; }
.icon-email:before { content: "✉️"; }

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.beian-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
}

.beian-link:hover {
  color: #76b6ff;
  text-decoration: underline;
}

.social-links {
  display: flex;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-left: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  color: #fff;
  text-decoration: none;
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
}

.wordall {
  display: none;
}

@media screen and (max-width: 768px) {
  .footer-top {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-logo {
    margin: 0 0 20px;
  }
  
  .footer-info {
    flex-direction: column;
  }
  
  .info-item {
    flex: 1 0 100%;
    justify-content: center;
  }
  
  .footer-bottom {
    flex-direction: column;
  }
  
  .copyright {
    margin-bottom: 15px;
  }
  
  .social-links {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterHtm.vue